import { ReactNode } from 'react';
import { Logo } from '@shared/widgets';

interface HeaderPrintableContentType {
  children?: ReactNode;
}

export const HeaderPrintableContent = (props: HeaderPrintableContentType) => {
  return (
    <div className='header-container'>
      <div className='header-content'>
        <div className='header-logo'>
          <Logo fill='#666666' />
        </div>
        <div className='header-support-text'>
          24 HOUR PHONE SUPPORT
          <br />
          +44 203 530 5053 / 0 800 955 0707
        </div>
      </div>
      {props.children && <div className='header-children'>{props.children}</div>}
    </div>
  );
};
